(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_7336a75"] && !Shopify.designMode) return;
  try {
    (function() {
    function initRotatingBars() {
      document.querySelectorAll('.rotating-announcement-bar[data-interval]').forEach(function(bar) {
        var interval = parseInt(bar.getAttribute('data-interval'), 10) * 1000;
        var messages = bar.querySelectorAll('.rotating-announcement-bar__message');
        var currentIndex = 0;

        if (messages.length < 2) return;

        setInterval(function() {
          var current = messages[currentIndex];
          var next = messages[(currentIndex + 1) % messages.length];

          current.classList.add('rotating-announcement-bar__message--fading-out');

          setTimeout(function() {
            current.style.display = 'none';
            current.classList.remove('rotating-announcement-bar__message--fading-out');
            next.style.display = 'block';
            currentIndex = (currentIndex + 1) % messages.length;
          }, 500);
        }, interval);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRotatingBars);
    } else {
      initRotatingBars();
    }

    document.addEventListener('shopify:section:load', initRotatingBars);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_8a03ebb"] && !Shopify.designMode) return;
  try {
    (function() {
    function initCountdownTimers() {
      document.querySelectorAll('.countdown-timer-bar[data-end-date]').forEach(function(bar) {
        var endDate = bar.getAttribute('data-end-date');
        var endTime = bar.getAttribute('data-end-time') || '00:00:00';
        var endDateTime = new Date(endDate + 'T' + endTime);

        var daysEl = bar.querySelector('[data-days]');
        var hoursEl = bar.querySelector('[data-hours]');
        var minutesEl = bar.querySelector('[data-minutes]');
        var secondsEl = bar.querySelector('[data-seconds]');

        function updateTimer() {
          var now = new Date();
          var diff = endDateTime - now;

          if (diff <= 0) {
            bar.classList.add('countdown-timer-bar--ended');
            return;
          }

          var days = Math.floor(diff / (1000 * 60 * 60 * 24));
          var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((diff % (1000 * 60)) / 1000);

          if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
          if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
          if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
          if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
        }

        updateTimer();
        setInterval(updateTimer, 1000);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCountdownTimers);
    } else {
      initCountdownTimers();
    }

    // Re-init on Shopify section load (for customizer)
    document.addEventListener('shopify:section:load', initCountdownTimers);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_e0810d7"] && !Shopify.designMode) return;
  try {
    (function() {
    function initSimpleCountdowns() {
      document.querySelectorAll('.simple-countdown-bar[data-end-date]').forEach(function(bar) {
        var endDate = bar.getAttribute('data-end-date');
        var endTime = bar.getAttribute('data-end-time') || '00:00';
        var endDateTime = new Date(endDate + 'T' + endTime + ':00');
        var daysEl = bar.querySelector('[data-days]');

        function updateCountdown() {
          var now = new Date();
          var diff = endDateTime - now;

          if (diff <= 0) {
            if (daysEl) daysEl.textContent = '0';
            return;
          }

          var days = Math.floor(diff / (1000 * 60 * 60 * 24));
          if (daysEl) daysEl.textContent = days;
        }

        updateCountdown();
        setInterval(updateCountdown, 60000); // Update every minute
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSimpleCountdowns);
    } else {
      initSimpleCountdowns();
    }

    document.addEventListener('shopify:section:load', initSimpleCountdowns);
  })();
  } catch(e) { console.error(e); }
})();

})();
